import React from 'react';
import { CommonProp, LayoutHorizontal, generate, BreadcrumbsItem } from '@acin/ui-core';
import * as SC from './PageLayout.styled';
import { MainNav } from '../../MainNav';

export interface PageLayoutProps extends CommonProp {
  className?: string;
  breadcrumbs?: BreadcrumbsItem[];
  onBreadcrumbsClick?: (item: BreadcrumbsItem) => void;
}

export const PageLayout: React.FC<PageLayoutProps> = (props) => {
  const { className, children, breadcrumbs, onBreadcrumbsClick } = props;

  return (
    <SC.PageLayout data-testid={generate(['page-layout'], props)} className={className}>
      <LayoutHorizontal
        renderNavigation={() => <MainNav breadcrumbs={breadcrumbs} onBreadcrumbsClick={onBreadcrumbsClick} />}
        renderContent={() => children}
      />
    </SC.PageLayout>
  );
};
